<template>
    <span>{{ relativeTime }}</span>
</template>
<script>
import moment from 'moment'

export default {
    name: 'RelativeTime',
    props: {
        timestamp: {
            required: true,
            type: Number
        }
    },

    data() {
        return {
            relativeTime: null
        }
    },

    created() {
        this.setRelativeTime()
    },

    methods: {
        setRelativeTime() {
            this.relativeTime = moment.unix(this.timestamp).fromNow()

            setTimeout(this.setRelativeTime, 60 * 1000)
        }
    }
}
</script>
